<template>
  <div>
    <q-form
      ref="paymentDetail"
      class="payment-form"
      :model="payment"
      :rules="rules"
      label-width="200px"
    >
      <q-form-item
        v-if="isSuccess"
        label="شماره سند"
        prop="number"
      >
        <h3>{{ resultMessage }}</h3>
      </q-form-item> 
      
      <q-form-item
        label="سال"
        prop="year"
      >
        <q-input-number
          v-model="payment.year"
        />
      </q-form-item>

      <q-form-item
        label="ماه"
        prop="month"
      >
        <q-input-number
          v-model="payment.month"
        />
      </q-form-item>

      <q-form-item
        label="تاریخ"
        prop="date"
      >
        <persian-date-picker
          ref="date"
          v-model="paymentDate"
          :editable="true"
        />
      </q-form-item>

      <q-form-item
        label="از حساب"
        prop="sourceAccount"
      >
        <q-model-selector
          v-model="payment.sourceAccount"
          plugin="gama"
          delegate="getDetailAccountList"
          display-field="caption"
          value-field="id"
          placeholder="..."
          style="width: 100%"
        />
      </q-form-item>

      <q-form-item
        ref="toAccount"
        label="به حساب"
        prop="toAccount"
        autofocus
      >
        <q-model-selector
          ref="toAccount"
          v-model="payment.toAccount"
          autofocus
          plugin="gama"
          delegate="getDetailAccountList"
          display-field="caption"
          value-field="id"
          placeholder="..."
          style="width: 100%"
        />
      </q-form-item>

      <q-form-item
        label="شرح"
        prop="note"
      >
        <q-input
          v-model="payment.note"
          rows="4"
        />
      </q-form-item>

      <q-form-item
        label="مبلغ"
        prop="amount"
      >
        <q-money
          v-model="payment.amount"
        />
      </q-form-item>

      <q-form-item>
        <q-button
          type="primary"
          class="persist-button"
          @click="persist()"
        >
          <span>اضافه کن</span>
        </q-button>
      </q-form-item>
    </q-form>
  </div>
</template>

<script>

  export default {
    name: "QGamaPaymentDetail",

    props: {
      formStructure: {required: true, type: Object}
    },
    data() {
      return {
        isSuccess: false,
        resultMessage: '--',
        paymentDate: '',
        payment: {
          number: 0,
          date: undefined,
          year: 0,
          month: 0,
          day: 0,
          amount: 0,
          sourceAccount: undefined,
          toAccount: undefined,
          note: '',
        },

        rules: {
          date: [
            {required: true, message: 'تاریخ پرداخت را وارد کنید', trigger: 'blur'}
          ],
          year: [
            {required: true, message: 'حتما سال پرداخت را انتخاب کنید', trigger: 'blur'},
            {type: 'number', min: 1395, max: 1420, message: 'سال بین 1395 و 1420 وارد کنید', trigger: 'blur'}
          ],
          month: [
            {required: true, message: 'ماه مربوط به پرداخت را انتخاب کنید', trigger: 'blur'},
            {type: 'number', min: 1, max: 12, message: 'ماه باید بین 1 تا 12 باشد', trigger: 'blur'}
          ],
          amount: [
            {required: true, message: 'مبلغ را وارد کنید', trigger: 'blur'}
          ],
          sourceAccount: [
            {required: true, message: 'حساب مبداء را انتخاب کنید', trigger: 'blur'}
          ],
          toAccount: [
            {required: true, message: 'حساب مقصد را انتخاب کنید', trigger: 'blur'}
          ],
          note: [
            {required: true, message: 'شرح را وارد کنید', trigger: 'blur'},
          ],
        }
      };
    },
    computed: {},
    watch: {

    },
    mounted() {
    },
    methods: {
      persist() {
        this.payment.date = this.paymentDate;
        this.$refs['paymentDetail'].validate((valid) => {
          if (valid) {
            this.$delegate('gama', 'addPayment', {
              payment: this.payment
            }).then((response) => {
              this.$notify({
                title: this.$qt('model.successPersistTitle'),
                message: response.message,
                type: 'success'
              });
              this.isSuccess = true;
              this.resultMessage = response.result.savedModel.number;
              this.payment.number = '';
              this.payment.toAccount = undefined;
              this.payment.day = 0;
              this.payment.amount = 0;
              this.payment.note = '';
              // this.$refs.toAccount.focus();
              this.$refs.toAccount.$el.getElementsByTagName('input')[0].focus();
            }).catch(() => {
            });
          } else {
            this.$notify({
              title: this.$qt('notify.exceptionTitle'),
              message: this.$qt('validation.completeFormMessage'),
              type: 'warning'
            });
            return false;
          }
        });
      }
    },
  };

</script>

<style scoped>
    .result-box {
        width: 400px;
        margin: 10px 150px 0 10px;
    }

    .payment-form {
        padding: 10px;
    }

    .persist-button:hover, .persist-button:focus {
        background-color: red;
    }

</style>
